class Accordion {
    constructor(el, {
        openClass = 'is-active',
        itemSelector = '[data-accordion-item]',
        panelSelector = '[data-accordion-panel]',
        triggerSelector = '[data-accordion-trigger]',
    }) {
        this.el = el;
        this.itemSelector = itemSelector;
        this.openClass = openClass;
        this.panelSelector = panelSelector;
        this.triggerSelector = triggerSelector;
    }

    close(panel) {
        panel.classList.remove(this.openClass);
        panel.setAttribute('aria-hidden', 'true');

        const item = panel.closest(this.itemSelector);
        let trigger = item.querySelector(this.triggerSelector);
        trigger.setAttribute('aria-expanded', 'false');
    }

    open(panel) {
        panel.classList.add(this.openClass);
        panel.setAttribute('aria-hidden', 'false');

        const item = panel.closest(this.itemSelector);
        const trigger = item.querySelector(this.triggerSelector);
        trigger.setAttribute('aria-expanded', 'true');
    }

    // `= (event) =>` to maintain class context
    toggle = (event) => {
        // init
        event.preventDefault();

        const trigger = event.currentTarget;
        const item = trigger.closest(this.itemSelector);
        const panel = item.querySelector(this.panelSelector);

        // need to define this before closing all the panels
        const shouldOpenCurrentPanel = !panel.classList.contains(this.openClass)

        // close all open panels
        const openPanels = this.el.querySelectorAll(`${this.panelSelector}.${this.openClass}`);
        Array.from(openPanels).forEach(panel => {
            this.close(panel);
        });

        // don't need to worry about closing panels here because we're closing all panels above
        if (shouldOpenCurrentPanel) {
            this.open(panel);
        }
    }

    init() {
        const triggers = this.el.querySelectorAll(this.triggerSelector);

        Array.from(triggers).forEach(node => {
            const panel = this.el.querySelector(this.panelSelector);

            if (!panel.id) {
                panel.id = `accordion-${Math.floor(Math.random() * 1000)}`;
                node.setAttribute('aria-controls', panel.id);
            }
            if (this.el.classList.contains(this.openClass)) {
                node.setAttribute('aria-expanded', 'true');
                panel.setAttribute('aria-hidden', 'false');
            } else {
                node.setAttribute('aria-expanded', 'false');
                panel.setAttribute('aria-hidden', 'true');
            }

            node.addEventListener('click', this.toggle);
            node.setAttribute('aria-controls', panel.id);
        });
    }
}

export default function init(el, args) {
    const accordion = new Accordion(el, args);
    accordion.init();
}
